import { BaseModel } from "sjs-base-model";

export default class GetAppuntamentiModel extends BaseModel {
    readonly idAppointment: number = 0;
    readonly object: string = "";
    readonly text: string = "";
    readonly appointmentDate: string = "";
    readonly startTime: string = "";
    readonly endTime: string = "";
    readonly creationDate: string = "";
    readonly cityCode: string = "";
    readonly addressTypeCode: string = "";
    readonly address: string = "";
    readonly civicNumber: string = "";

    constructor(data: Partial<GetAppuntamentiModel>) {
        super();

        this.update(data);
    }
}
